$(document).ready(function() {
  $(document).on('click', '.ph-print-order', function() {
    var printorderList = '.ph-printorder-list',
        currentUrl = new URL(location.href);

    $(printorderList).removeClass('ph-print-displayNone');

    var printBlock = $(this).parents(printorderList).siblings(printorderList);

    printBlock.addClass('ph-print-displayNone');
    window.print();
    currentUrl.searchParams.append('resetpassword');
  });
});

